module.exports = __webpack_public_path__ + "img/test.a142d3a1.jpg";